'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'bags-shopping';
var width = 576;
var height = 512;
var aliases = [128717];
var unicode = 'f847';
var svgPathData = ['M16 160c0-26.5 21.5-48 48-48l320 0c26.5 0 48 21.5 48 48l0 16-176 0c-61.9 0-112 50.1-112 112l0 144-80 0c-26.5 0-48-21.5-48-48l0-224z', 'M160 48l0 48 128 0 0-48c0-35.3-28.7-64-64-64s-64 28.7-64 64zM144 96l0-48c0-44.2 35.8-80 80-80s80 35.8 80 80l0 48 80 0c35.3 0 64 28.7 64 64l0 16-16 0 0-16c0-26.5-21.5-48-48-48L64 112c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l80 0 0 16-80 0c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l80 0zm64 192l0 160c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-256 0c-26.5 0-48 21.5-48 48zm-16 0c0-35.3 28.7-64 64-64l256 0c35.3 0 64 28.7 64 64l0 160c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-160zm120 24c4.4 0 8 3.6 8 8l0 32c0 35.3 28.7 64 64 64s64-28.7 64-64l0-32c0-4.4 3.6-8 8-8s8 3.6 8 8l0 32c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-32c0-4.4 3.6-8 8-8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBagsShopping = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;